export default __webpack_public_path__ + "static/media/Beastmaster's Bevor.0967c6bd.jpg";